// Medición del embudo en Matomo (mismo sitio que gestdoc.cl para atribuir cada trámite a su canal).
// Solo se activa si el build trae REACT_APP_MATOMO_URL y REACT_APP_MATOMO_SITE_ID.
// Nunca se envían correos, RUT ni IDs de trámite: las URLs se anonimizan antes de medir.
const URL_MATOMO = (process.env.REACT_APP_MATOMO_URL || "").replace(/\/+$/, "");
const ID_SITIO = process.env.REACT_APP_MATOMO_SITE_ID;
// Dominio de la cookie para compartir el visitante con el sitio público, ej. "*.gestdoc.cl"
const DOMINIO_COOKIE = process.env.REACT_APP_MATOMO_COOKIE_DOMAIN;

const activo = Boolean(URL_MATOMO && ID_SITIO);
let visitorId = null;

const push = (...args) => {
  if (!activo) return;
  window._paq = window._paq || [];
  window._paq.push(args);
};

export function iniciarMatomo() {
  if (!activo || window._paqIniciado) return;
  window._paqIniciado = true;
  window._paq = window._paq || [];
  push("setTrackerUrl", `${URL_MATOMO}/matomo.php`);
  push("setSiteId", ID_SITIO);
  if (DOMINIO_COOKIE) {
    push("setCookieDomain", DOMINIO_COOKIE);
    push("setDomains", [DOMINIO_COOKIE]);
  }
  // El ID de visitante se guarda en memoria para enviarlo al backend sin esperar al tracker
  window._paq.push([
    function () {
      visitorId = this.getVisitorId();
    },
  ]);
  const script = document.createElement("script");
  script.async = true;
  script.src = `${URL_MATOMO}/matomo.js`;
  document.head.appendChild(script);
}

// ID de visitante de Matomo (16 caracteres hex) o null si aún no está disponible
export const obtenerVisitorId = () => visitorId;

// Quita de la ruta los IDs de trámite, códigos cortos y tokens
export function rutaAnonima(pathname) {
  const p = pathname.replace(/\/+$/, "");
  if (p.startsWith("/procedure")) return "/procedure";
  if (p.startsWith("/signaturedoc")) return "/signaturedoc";
  if (p.startsWith("/p/")) return "/p/:codigo";
  if (p.startsWith("/q/")) return "/q/:codigo";
  if (p.startsWith("/verification_email/")) return "/verification_email";
  if (p.startsWith("/forgot_email/")) return "/forgot_email";
  return p || "/";
}

export function vistaPagina(ruta, titulo) {
  if (!activo) return;
  push("setCustomUrl", `${window.location.origin}${ruta}`);
  push("setDocumentTitle", titulo || document.title);
  push("trackPageView");
}

export function evento(categoria, accion, nombre, valor) {
  const args = ["trackEvent", categoria, accion];
  if (nombre !== undefined) args.push(nombre);
  if (valor !== undefined) args.push(valor);
  push(...args);
}
